
























































































































import Vue from 'vue'
import { GetById as getDevice, FindDriver, Patch, Delete } from '@/api/device'
import { Driver, Device } from '@/../ui/types/device'
declare interface OptionDriver {
  value: string
  text: string
}

export default Vue.extend({
  data() {
    return {
      detailDevice: {} as Device,
      optionDriver: [] as OptionDriver[],
      selectedDriver: '',
      listDriver: [] as Driver[],
      usedDriver: {} as Driver | undefined,
      nameDevice: '',
    }
  },
  methods: {
    async findDevice(id: number) {
      this.detailDevice = await getDevice(id)
      this.nameDevice = this.detailDevice.name
      this.findDriver()
    },

    async findDriver() {
      this.listDriver = await FindDriver()
      const options = []
      for (let i = 0; i < this.listDriver.length; i++) {
        const driver = this.listDriver[i]

        const option = { value: driver.name, text: driver.title }
        options.push(option)
      }

      this.optionDriver = options
      this.selectedDriver = this.detailDevice.driver
      this.generateFieldsConfig(this.selectedDriver)
    },
    onDriverChange() {
      this.generateFieldsConfig(this.selectedDriver)
      this.detailDevice.config = this.usedDriver?.default
    },
    async generateFieldsConfig(driver: string) {
      this.usedDriver = this.listDriver.find((element: Driver) => {
        return element.name === driver
      })
    },

    async updateConfiguration() {
      try {
        console.log(this.detailDevice)
        await Patch(this.detailDevice.id, this.detailDevice)
        this.$toast.success('Device Updated')
        this.$router.push('/cems/setting/device')
      } catch (error) {
        console.log(error)
      }
    },
    async deleteDevice() {
      let message = ''

      try {
        await Delete(this.detailDevice.id)
        message = `${this.detailDevice.name} device successfully deleted`
        this.$toast.success(message)
        this.$router.push('/cems/setting/device')
      } catch (error) {
        console.log(error)
      }
    },
  },

  created() {
    const deviceId = this.$route.params.deviceId
    this.findDevice(parseInt(deviceId))
  },
})
